import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";
import { format } from "date-fns";

import { FaDownload } from "react-icons/fa";

import { Flex, Button, Link, Icon, SimpleGrid, Box } from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import Table from "./Table";
import NaoPossui from "./NaoPossui";

import { API } from "../../../../main/config";
import PlanejamentoSAService from "../../../../main/services/PlanejamentoSAService";

import Group from "../Visualizar/Group";
import {
  criancaFunc,
  Permission,
  servicos,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import { useAppContext } from "../../../../Context/MessageContextProvider";

const PlanejamentoServicoAcolhimento = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const columnsPlanoTrabalho = [
    {
      Header: "Possui Plano de Trabalho",
      accessor: "possuiPlanoTrabalho",
      Cell: (props) => {
        return <span>{props.value === "S" ? "SIM" : "NÃO"}</span>;
      },
    },
    {
      Header: "Última atualização",
      accessor: "dataAtualizacaoPlanoTrabalho",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Plano de Trabalho",
      accessor: "anexoPlanoTrabalho",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </span>
        );
      },
    },
  ];

  const columnsProjetoPoliticoPedagogico = [
    {
      Header: "Possui Projeto Político-pedagógico",
      accessor: "possuiPPP",
      Cell: (props) => {
        return <span>{props.value === "S" ? "SIM" : "NÃO"}</span>;
      },
    },
    {
      Header: "Última atualização",
      accessor: "dataAtualizacaoPPP",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Projeto Político-Pedagógico",
      accessor: "anexoPPP",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </span>
        );
      },
    },
  ];

  const columnsRelatorioAnual = [
    {
      Header: "Possui Relatório Anual",
      accessor: "possuiRelatorioAnual",
      Cell: (props) => {
        return <span>{props.value === "S" ? "SIM" : "NÃO"}</span>;
      },
    },
    {
      Header: "Última atualização",
      accessor: "dataApresentacaoRelatorio",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Relatório Anual",
      accessor: "anexoRelatorioAnual",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </span>
        );
      },
    },
  ];

  const columnsRegimentoInterno = [
    {
      Header: "Possui Regime Interno",
      accessor: "possuiRegimentoInterno",
      Cell: (props) => {
        return <span>{props.value === "S" ? "SIM" : "NÃO"}</span>;
      },
    },
    {
      Header: "Última atualização",
      accessor: "dataAtualizacaoRegimento",
      Cell: (props) => {
        return (
          <span>{props.value ? format(props.value, "dd/MM/yyyy") : ""}</span>
        );
      },
    },
    {
      Header: "Regimento Interno",
      accessor: "anexoRegimento",
      Cell: (props) => {
        return (
          <span>
            {props.value && (
              <Link
                href={
                  props.value.pathAnexo.toString().includes(".png") ||
                  props.value.pathAnexo.toString().includes(".jpg") ||
                  props.value.pathAnexo.toString().includes(".jpeg") ||
                  props.value.pathAnexo.toString().includes(".pdf")
                    ? API + `/anexos/${props.value.id}/visualizar`
                    : API + `/anexos/${props.value.id}/download`
                }
                target="_blank"
              >
                <Icon
                  aria-label="Download"
                  color="#006064"
                  as={FaDownload}
                  boxSize="18px"
                  _hover={{ cursor: "pointer" }}
                />
              </Link>
            )}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    PlanejamentoSAService.getPlanejamentoSA(id)
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status === 404) {
            history.push(`/servico-acolhimento/cadastrar-planejamento/${id}`);
          }
        }
      });
  }, [history, id]);

  return roleKeycloack &&
    (roleKeycloack.includes(servicos.planejamentoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loading && data ? (
      <>
        <Group title="Plano de Trabalho">
          {data.possuiPlanoTrabalho === "S" ? (
            <Table data={[data]} columns={columnsPlanoTrabalho} />
          ) : (
            <NaoPossui />
          )}
        </Group>
        <Group title="Projeto Político-Pedagógico">
          {data.possuiPPP === "S" ? (
            <Table data={[data]} columns={columnsProjetoPoliticoPedagogico} />
          ) : (
            <NaoPossui />
          )}
        </Group>

        <Group title="Relatório Anual">
          {data.possuiRelatorioAnual === "S" ? (
            <Table data={[data]} columns={columnsRelatorioAnual} />
          ) : (
            <NaoPossui />
          )}
        </Group>
        <Group title="Regimento Interno">
          {data.possuiRegimentoInterno === "S" ? (
            <Table data={[data]} columns={columnsRegimentoInterno} />
          ) : (
            <NaoPossui />
          )}
        </Group>

        <SimpleGrid
          mt="30px"
          columns={{ base: 1, sm: 2, lg: 5 }}
          spacing="20px"
          dir="rtl"
        >
          <Permission
            roleKeycloack={roleKeycloack}
            func={servicos.planejamentoEditar}
            id={idPJ}
            user={user}
          >
            <Button
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={700}
              fontSize="15px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              onClick={() => {
                history.push(`/servico-acolhimento/editar-planejamento/${id}`);
              }}
            >
              Editar
            </Button>
          </Permission>
        </SimpleGrid>
      </>
    ) : (
      <Flex w="100%" mt="25%" justifyContent="center">
        <LoadingSpinner />
      </Flex>
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};

export default PlanejamentoServicoAcolhimento;
